import { useTranslation } from "react-i18next";
import { LegalShell } from "@/pages/legal/Terms";

const BLOCKS = [["hData", "pData"], ["hIso", "pIso"], ["hAccess", "pAccess"], ["hSec", "pSec"], ["hRights", "pRights"]];

export function PrivacyContent() {
  const { t } = useTranslation();
  return (
    <>
      <p dangerouslySetInnerHTML={{ __html: t("lg.pv.intro") }} />
      {BLOCKS.map(([h, p]) => (
        <div key={h}>
          <h3 className="font-heading text-lg font-bold text-navy">{t(`lg.pv.${h}`)}</h3>
          <p className="mt-1" dangerouslySetInnerHTML={{ __html: t(`lg.pv.${p}`) }} />
        </div>
      ))}
    </>
  );
}

export default function Privacy() {
  const { t } = useTranslation();
  return <LegalShell title={t("lg.privacyTitle")}><PrivacyContent /></LegalShell>;
}
